import './assets/main.css'

import { createApp as _createApp } from 'vue'
import App from './App.vue'
import router from './router'

// 客户端入口
if (typeof window !== 'undefined') {
  _createApp(App).use(router).mount('#app')
}

// SSR导出
export function createApp() {
  const app = _createApp(App)
  app.use(router)
  return { app, router }
}